import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarTypes } from '../_enums/snackbar.types';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(
    private matSnackBar: MatSnackBar,
    private translate: TranslateService,
    private dialog: MatDialog
  ) {}

  open(type: string, action: string = '', duration: number = 2500) {
    if (!action) action = this.translate.instant('common_close');
    let message;
    switch (type) {
      case SnackbarTypes.delete:
        message = this.translate.instant('snackbar_delete_success');
        break;
      case SnackbarTypes.update:
        message = this.translate.instant('snackbar_update_success');
        break;
      case SnackbarTypes.add:
        message = this.translate.instant('snackbar_add_success');
        break;
      case SnackbarTypes.duplicate:
        message = this.translate.instant('snackbar_duplicate_success');
        break;
      case SnackbarTypes.share:
        message = this.translate.instant('snackbar_share_success');
        break;
      case SnackbarTypes.publish:
        message = this.translate.instant('snackbar_publish_success');
        break;
      case SnackbarTypes.error:
        message = this.translate.instant('snackbar_error');
        break;
      case SnackbarTypes.errorUserNotFound:
        message = this.translate.instant('snackbar_error_user_not_found');
        break;
      case SnackbarTypes.errorUploadLogo:
        message = this.translate.instant('snackbar_error_upload_logo');
        break;
      case SnackbarTypes.addFavorite:
        message = this.translate.instant('snackbar_add_favorite');
        break;
      case SnackbarTypes.deleteFavorite:
        message = this.translate.instant('snackbar_delete_favorite');
        break;
      case SnackbarTypes.mailReinitPasswordSend:
        message = this.translate.instant('snackbar_mail_reinit_password_sent');
        break;
      case SnackbarTypes.mailInitSend:
        message = this.translate.instant('snackbar_mail_init_sent');
        break;
      case SnackbarTypes.mailSend:
        message = this.translate.instant('snackbar_mail_sent');
        break;
      case SnackbarTypes.compositionUpdate:
        message = this.translate.instant('snackbar_composition_updated');
        break;
      case SnackbarTypes.projectAgencyOwner:
        message = this.translate.instant('snackbar_owner_updated');
        break;
      case SnackbarTypes.accountActivated:
        message = this.translate.instant('snackbar_account_activated');
        break;
      case SnackbarTypes.reject:
        message = this.translate.instant('snackbar_registration_rejected');
        break;
      case SnackbarTypes.noEcoProAccount:
        message = this.translate.instant('snackbar_no_ecopro_account');
        break;
      case SnackbarTypes.indicatorRequiert:
        message = this.translate.instant('snackbar_indicator_required');
        break;
      case SnackbarTypes.massRequired:
        message = this.translate.instant('product_error_mass_required');
        break;
      case SnackbarTypes.resetPasswordTokenExpired:
        message = this.translate.instant('snackbar_reset_password_token_expired');
        break;
      case SnackbarTypes.differentSolutionVersionId:
        message = this.translate.instant('snackbar_different_solution_version');
        break;
      case SnackbarTypes.shareProject:
        message = this.translate.instant('snackbar_action_success');
        break;
      case SnackbarTypes.VersionProject:
        message = this.translate.instant('snackbar_version_project_old');
        break;
      case SnackbarTypes.VersionProjectCheck:
        message = this.translate.instant('snackbar_version_project_check');
        break;
      case SnackbarTypes.ResourceNotAvailableForversion:
        message = this.translate.instant('snackbar_resource_not_available');
        break;
      case SnackbarTypes.ResourceUFNotAvailableForversion:
        message = this.translate.instant('snackbar_resource_uf_not_available');
        break;
      default:
        message = type;
        break;
    }
    return this.matSnackBar.open(message, action, { duration });
  }

  openServerError(error: any, action: string = '') {
    // ErrorIntercept réduit la réponse au message du serveur et affiche lui-même celui d'un refus (403).
    if (typeof error === 'string') {
      if (this.dialog.openDialogs.length > 0) return;
      if (error && !error.startsWith('Error Status:')) this.showMessage(error);
      else this.open(SnackbarTypes.error, action);
      return;
    }
    if (error?.status === 403 && typeof error.error === 'string' && error.error) this.showMessage(error.error);
    else this.open(SnackbarTypes.error, action);
  }

  showMessage(message: string, options?: any) {
    this.matSnackBar.open(message, this.translate.instant('common_close'));
  }

  openError(error: any) {
    if (this.isCodeAlreadyExists(error)) this.showMessage(this.translate.instant('error_code_already_exists'));
    else this.open(SnackbarTypes.error);
  }

  isCodeAlreadyExists(error: any): boolean {
    // ErrorIntercept réduit la réponse au message du serveur.
    if (typeof error === 'string') return error === 'Ce code existe déjà';
    const failures = Array.isArray(error?.error) ? error.error : [];
    return failures.some((failure: any) => failure?.errorCode === 'CodeAlreadyExists');
  }
}
